import { render, staticRenderFns } from "./SoMain.vue?vue&type=template&id=1b3b67b0&scoped=true"
import script from "./SoMain.vue?vue&type=script&lang=js"
export * from "./SoMain.vue?vue&type=script&lang=js"
import style0 from "./SoMain.vue?vue&type=style&index=0&id=1b3b67b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b67b0",
  null
  
)

export default component.exports